import DDLogs from '../DDLogs';
import { ProgradPostback } from '../types/postback';
import { clientWithoutInterceptors } from '../utils/http';

export async function createPostback(postback: ProgradPostback, customerId: string): Promise<void> {
  try {
    await clientWithoutInterceptors.post('/api/prograd-postback', postback);
  } catch (error) {
    DDLogs.error('Failed to create postback:', {
      error: error instanceof Error ? error.message : String(error),
      postback,
      customerId,
    });
  }
}
